import { css } from 'react-emotion';
import { breakpoints } from '@joykit/variables/breakpoints';

export namespace styles {
  export const exitButton = css({
    width: '15px',
    height: '15px',
    top: '-1.5em',
    right: '-1.5em',
    cursor: 'pointer',
    position: 'absolute',
    ' svg': {
      width: '100%',
      height: 'auto',
      ' path': {
        fill: 'white'
      }
    },
    [`@media(max-width: ${breakpoints.small - 1}px)`]: {
      top: '22.5px',
      right: '20px',
      '> path': {
        fill: '#333'
      }
    }
  });

  export const actions = css({
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    padding: '8px',
    width: '100%',
    textAlign: 'right'
  });
}
